import { render, staticRenderFns } from "./PermissionFilter.vue?vue&type=template&id=f75f11e8&"
import script from "./PermissionFilter.vue?vue&type=script&lang=babel&"
export * from "./PermissionFilter.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports